import {EMPTY, filter, mergeMap, Observable, withLatestFrom, from} from "rxjs";
import { Action } from "@reduxjs/toolkit";
import {nextStep, Media, startUpload, uploadFile} from "../slices";
import {currentStep, selectFiles} from "../selectors";

export const processFilesEpic = (
  action$: Observable<Action>,
  state$: Observable<any>
) => {
  return action$.pipe(
    filter(nextStep.match),
    withLatestFrom(state$),
    mergeMap(([_, state]) => {

      const step = currentStep(state);
      if (step !== Media.UPLOAD) return EMPTY;

      const files: File[] = selectFiles(state);

      if (!files || files.length === 0) {
        return EMPTY;
      }

      const uploadActions = files.map(file => 
        uploadFile({ fileName: file.name, file })
      );

      return from([
        startUpload(files.map(f => f.name)),
        ...uploadActions
      ]);
    })
  );
};
